export enum ParticipantConst {
  DELETE_PARTICIPANTS = 'DELETE:PARTICIPANTS',
  DELETE_PARTICIPANTS_OK = 'DELETE:PARTICIPANTS:OK',
  DELETE_PARTICIPANTS_KO = 'DELETE:PARTICIPANTS:KO',
  CANCEL_DELETE_PARTICIPANTS = 'CANCEL:DELETE:PARTICIPANTS',
}
